import { render, staticRenderFns } from "./commodityMarket.vue?vue&type=template&id=13c48d72&scoped=true"
import script from "./commodityMarket.vue?vue&type=script&lang=js"
export * from "./commodityMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c48d72",
  null
  
)

export default component.exports